'use client';

import React from 'react';
import { motion } from 'framer-motion';
import SectionBase from '@/components/ui/sections/section-base';
import SectionHeader from '@/components/ui/sections/section-header';
import { TypographyP } from '@/components/ui/typography';
import { cls } from '@/lib/utils';

const SECTION_ID = 'service-story';

const wrapperMotionProps = {
  initial: 'hidden' as const,
  whileInView: 'visible' as const,
  viewport: { once: true },
  variants: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  },
};

const itemMotionProps = {
  variants: {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  },
};

interface ServiceStorySectionProperties {
  storyTitle: string;
  storyParagraphs: string[];
}

function ServiceStorySection({
  storyTitle,
  storyParagraphs,
}: ServiceStorySectionProperties) {
  return (
    <SectionBase id={SECTION_ID} background="bg-background">
      <motion.div
        className={cls`flex flex-col items-center gap-8`}
        {...wrapperMotionProps}
      >
        <SectionHeader
          subtitle="OUR APPROACH"
          title={storyTitle}
          description="Learn how Cornerstone Homes approaches every design and build project with care, transparency, and 20+ years of experience."
        />

        <motion.div
          className={cls`flex flex-col gap-6 w-full max-w-3xl mx-auto`}
          {...itemMotionProps}
        >
          {storyParagraphs.map((paragraph, index) => (
            <motion.div key={`story-${index + 1}`} {...itemMotionProps}>
              <TypographyP className="text-foreground leading-relaxed">
                {paragraph}
              </TypographyP>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </SectionBase>
  );
}

export default ServiceStorySection;
